import { ChevronLeftIcon, PillButton, Typography, useBreakpoint } from "@povio/ui";

interface PageHeaderProps {
  title: string;
  button?: { label: string; action: () => void };
}

export const PageHeader = ({ title, button }: PageHeaderProps) => {
  const isDesktop = useBreakpoint("md");

  return (
    <div className="sticky top-0 z-20 flex items-center justify-start gap-6 bg-elevation-fill-default-0 p-6">
      {button && (
        <PillButton
          icon={ChevronLeftIcon}
          variant="outlined"
          color="secondary"
          onPress={button.action}
        >
          {button.label}
        </PillButton>
      )}
      {isDesktop && (
        <Typography
          size="title-4"
          variant="prominent-1"
          as="h1"
        >
          {title}
        </Typography>
      )}
    </div>
  );
};
